const React = require('react');
const withReDelay = require('mn-utils/withReDelay');

const {HeadCellAdmin, HeadCellAdminFilter} = require('../../../../TableHeadCell/components/HeadCellAdmin');
const {
  IntervalFilterAdmin,
} = require('../../../../IntervalFilterCustom');
const BtnTableGlobal = require("../../../Buttons/components/BtnTableGlobal");
const {AdminCheckbox} = require('../../../../../dumb/FormInputs');
const {default: EditIcon} = require("@material-ui/icons/Edit");
const openPopupNuveiBulkEdit = require("../../utils/openPopupNuveiBulkEdit");
const getDefaultFilterParams = require("../../../../IntervalFilterCustom/utils/getDefaultFilterParams");
const {apiAdminNuveiReconciliationStart} = require("../../../../../../api/admin/transactions");
const upperFirst = require("mn-utils/upperFirst");
const {DisplayStatusTrx} = require("../../../../StatusDisplay");
const UpdateIcon = require("@material-ui/icons/Update").default;

const STATUSES_LF_IDS = ['found', 'ignored', 'fixed'];

const lifeflowFilterHead = {
  name: 'lifeflow',
  list: ['all', ...STATUSES_LF_IDS].map((id) => {
    const name = id.split('_').map((el) => upperFirst(el)).join(' ');
    return {
      id,
      name,
      nameHeadDisplay: name
    }
  })
}

module.exports = ({self, filter$, items, report, showCustomer, fullSize}) => {
  const state = self.state;

  const update = withReDelay(self.update, 1000);
  function handleChangeFilter(filter) {
    filter$.emit({
      ...state.filter,
      ...filter,
    });
    update();
  }

  const filter = state.filter;
  const list = (self.state.data || {}).list || [];
  const selected = self.state.selected || [];
  const allSelected = list.length === selected.length;
  const noData = !state.data || !state.data.count;

  return (
    <>
      <IntervalFilterAdmin
        className="mt20 m0@m"
        data={filter}
        sort={state.sort}
        onChange={handleChangeFilter}
        report={report}
        update={self.update}
        // selectFilters={[STATUSES_FILTER_SELECT]}
        search={{
          className: 'wmin180 fx1',
          placeholder: 'Search',
        }}
        additionalBtns={(
          <>
            <div>
              <BtnTableGlobal
                icon={EditIcon}
                text="edit"
                onClick={() => {
                  const rawArr = allSelected
                    ? list
                    : list.filter((el) => selected.includes(el.id));

                  const arr = rawArr.map((el) => {
                    const {id, old_payment_invoice_lifeflow, new_transaction_lifeflow} = el;

                    const oldLifeflow = old_payment_invoice_lifeflow.toLowerCase();
                    const newLifeflow = new_transaction_lifeflow.toLowerCase();

                    const reviewKind = (
                          ['expired', 'cancelled'].includes(oldLifeflow)
                          && newLifeflow === 'success'
                      ) ? 'approved'
                        : (
                          ['success', 'accepted', 'approved'].includes(oldLifeflow)
                          && ['error', 'declined', 'cancelled'].includes(newLifeflow)
                        ) ? 'declined'
                          : '';

                    return {id, review_kind: reviewKind, old_status: `${old_payment_invoice_lifeflow} / ${new_transaction_lifeflow}`};
                  })

                  openPopupNuveiBulkEdit({selected: arr, update})
                }}
                disabled={!selected.length}
              />
            </div>
            <div>
              <BtnTableGlobal
                icon={UpdateIcon}
                text="start"
                onClick={() => {
                  const {from, to} = getDefaultFilterParams({state: {filter: {from: new Date('01-01-1970').getTime(), to: new Date().getTime()}}})
                  apiAdminNuveiReconciliationStart({from, to}).then(self.update);
                }}
              />
            </div>
          </>
        )}
      />
      <div className={`rlv hmin480 h100vh-440 h100vh-315@m2 h100vh-325.fullSize h100vh-210@m2.fullSize` + (fullSize ? ' fullSize' : '')}>
        <div className="ovxA abs s">
          <div className="wmin1360 rlv h">
            <div className="w abs bgE layoutRow aiStretch">
              <HeadCellAdmin className="wmin40 fx1">
                <div className="ml9">
                  <AdminCheckbox
                    value={allSelected}
                    onChange={(name, val) => {
                      if (val) {
                        self.setState({selected: list.map((el) => el.id)})
                      } else {
                        self.setState({selected: []})
                      }
                    }}
                  />
                </div>
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                ID
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Merchant
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Created At
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Amount
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Payment Method
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin200">
                Old Lifeflow
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin150">
                New Lifeflow
              </HeadCellAdmin>
              <HeadCellAdminFilter
                className="wmin150"
                filters={lifeflowFilterHead}
                handleChangeFilter={handleChangeFilter}
                self={self}
              >
                Lifeflow
              </HeadCellAdminFilter>
            </div>
            <div className="abs sh st45 sb c0>.CircularProgress">
              {items}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
